module.exports = __webpack_public_path__ + "img/0Q3A5468_L_BlackMatted.4d0e7677.jpg";